/**
 * Border radius tokens for Safe Wallet theme.
 * Used for consistent corner rounding across web and mobile.
 */

/**
 * Border radius scale (in pixels).
 * Used by both Tamagui and MUI for consistent rounded corners.
 */
export const radius = {
  0: 0,
  1: 2,
  2: 4,
  3: 6,
  4: 8,
  5: 12,
  6: 18,
  7: 20,
  8: 22,
  9: 24,
  10: 26,
  11: 30,
  12: 32,
  13: 36,
  14: 40,
  15: 44,
  16: 48,
  17: 52,
  18: 56,
  19: 60,
  20: 64,
} as const

/**
 * Default border radius for MUI components (6px).
 */
export const defaultRadius = 6
